module.exports = __webpack_public_path__ + "img/Dunasbilba.7bb657f7.jpg";